module.exports = __webpack_public_path__ + "img/9_40.f31f8c83.png";